import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=a32e3e34&scoped=true&"
import script from "./distribution.vue?vue&type=script&lang=js&"
export * from "./distribution.vue?vue&type=script&lang=js&"
import style0 from "./distribution.vue?vue&type=style&index=0&id=a32e3e34&lang=less&scoped=true&"
import style1 from "./distribution.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32e3e34",
  null
  
)

export default component.exports